import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { LanguageProvider } from './contexts/LanguageContext';
render(<LanguageProvider data-id="element-267" data-mp="1wd79uj1evx7a">
    <App data-id="element-268" data-mp="21a7gow6353zg" />
  </LanguageProvider>, document.getElementById('root'));